module.exports = __webpack_public_path__ + "static/img/Base + Pic.34332b5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dashboard/Base + Pic.svg
// module id = fppE
// module chunks = 37